import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { User } from '@/types/user';

export const getUser = async (email: string, role?: string): Promise<ApiResult<User>> => {
  const params = new URLSearchParams({
    email: email,
  });
  if (role) {
    params.append('role', role);
  }

  const searchParams = new URLSearchParams(params);
  const { status, result } = await callApi<User>(
    `users/user`,
    'GET',
    searchParams,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
